import { IPaymentMethod } from '@/models'
import { api } from '@/api/api'
import { PAYMENT_METHOD_TYPE } from '@/enums'

// TODO
function appendDescription(method: IPaymentMethod) {
    switch (method.type) {
        case PAYMENT_METHOD_TYPE.PAYU:
            return { ...method, description: 'Szybki przelew, płatność kartą lub BLIK' }
        case PAYMENT_METHOD_TYPE.PAYPAL:
            return { ...method, description: 'Szybki przelew lub płatność kartą' }
        default:
            return method
    }
}

export async function fetchPaymentMethods(shippingID: string): Promise<IPaymentMethod[]> {
    const {
        data: { methods },
    } = await api.get(`shipping/availablePaymentMethods/${shippingID}`)

    return methods.map(appendDescription)
}
